// src/pages/PagesUtilisateurs/DashboardUsers/components/DashboardSection.jsx

import React from "react";

const ACCENTS = {
  blue: "border-l-[#013E8E]",
  amber: "border-l-amber-500",
  emerald: "border-l-emerald-500",
  slate: "border-l-slate-400",
};

export default function DashboardSection({
  title,
  subtitle,
  icon: Icon,
  tone = "blue",
  children,
}) {
  return (
    <section
      className={`
        overflow-hidden
        rounded-[1.75rem]
        border border-slate-200
        border-l-4
        ${ACCENTS[tone] || ACCENTS.blue}
        bg-white
        shadow-sm
        dark:border-slate-800
        dark:bg-slate-900
      `}
    >
      <header className="border-b border-slate-100 px-4 py-5 dark:border-slate-800 sm:px-6">
        <div className="flex items-start gap-3">
          {Icon ? (
            <span
              className="
                flex h-10 w-10 shrink-0
                items-center justify-center
                rounded-xl
                bg-slate-100
                text-slate-600
                dark:bg-slate-800
                dark:text-slate-300
              "
            >
              <Icon />
            </span>
          ) : null}

          <div className="min-w-0">
            <h2 className="text-lg font-black text-slate-950 dark:text-white sm:text-xl">
              {title}
            </h2>

            {subtitle ? (
              <p className="mt-1 max-w-3xl text-xs leading-5 text-slate-500 dark:text-slate-400 sm:text-sm">
                {subtitle}
              </p>
            ) : null}
          </div>
        </div>
      </header>

      <div className="p-4 sm:p-6">
        {children}
      </div>
    </section>
  );
}